module.exports = __webpack_public_path__ + "img/panch_cuento_4.496ae80b.png";